module.exports = __webpack_public_path__ + "img/5_ECJ.f2ac8bdd.png";